export const API_URL = 'https://cms.weplus.id/api-assets'
// export const API_URL = 'http://localhost:8000'
export const GMAPS_API_KEY = 'AIzaSyA17QJttDXL2iJjvEZ5QBETiurwRhtMXFo'